import styled from 'styled-components';
import { Heading1, Heading3, BodyText } from '../Text/Text.style';
import { ButtonStyle } from '../Button/Button.style';
import Colors from '../../styles/colors';

export const ConnectWrapperStyle = styled.div`
  position: relative;
`;

export const ConnectSuccessScreenStyle = styled.div`
  text-align: center;
  ${Heading1}, ${BodyText} {
    text-align: center;
  }

  svg {
    margin: 20px 0 32px;

    @media (min-width: ${props => props.theme.breakpoints.mdMin}) {
      margin: 20px 0 40px;
    }
  }

  ${ButtonStyle} {
    margin-top: 32px;
    margin-bottom: 70px;

    @media (min-width: ${props => props.theme.breakpoints.mdMin}) {
      width: 240px;
      margin: 50px auto 40px;
    }
  }
`;

export const ConnectTopSectionStyle = styled.div`
  grid-column: 1/13;

  ${Heading1} {
    margin-bottom: 12px;
  }

  @media (min-width: ${props => props.theme.breakpoints.mdMin}) {
    ${Heading1} {
      margin-bottom: 18px;
    }
  }

  @media (min-width: ${props => props.theme.breakpoints.lgMin}) {
    margin-top: 30px;

    ${Heading1} {
      text-align: center;
    }

    ${BodyText} {
      max-width: 845px;
      margin: 0 auto;
      text-align: center;
    }
  }
`;

export const ConnectLeftSectionStyle = styled.div`
  grid-column: 1/13;

  @media (min-width: ${props => props.theme.breakpoints.mdMin}) {
    text-align: center;
  }

  @media (min-width: ${props => props.theme.breakpoints.lgMin}) {
    grid-column: 1/7;
    margin-bottom: 70px;
    padding-right: 30px;
    text-align: right;
  }
`;

export const ConnectRightSectionStyle = styled.div`
  grid-column: 1/13;
  margin-bottom: 70px;

  ${Heading1} {
    margin-bottom: 12px;
  }

  @media (min-width: ${props => props.theme.breakpoints.mdMin}) {
    margin-bottom: 40px;

    ${Heading1} {
      margin-bottom: 18px;
    }
  }

  @media (min-width: ${props => props.theme.breakpoints.lgMin}) {
    grid-column: 7/13;
    margin-bottom: 70px;
    padding-top: 28px;

    ${BodyText} {
      max-width: 520px;
    }
  }
`;

export const ConnectSmartTvImageStyle = styled.div`
  img {
    max-width: 100%;
  }
`;

export const ConnectLoggedOutStyle = styled.div`
  display: grid;
  grid-row-gap: 20px;
  margin-top: 43px;

  @media (min-width: ${props => props.theme.breakpoints.mdMin}) {
    grid-column-gap: 18px;
    grid-template-columns: 1fr 1fr;

    ${ButtonStyle} {
      width: 228px;
    }

    ${ButtonStyle}:first-child {
      justify-self: end;
    }

    ${ButtonStyle}:last-child {
      justify-self: start;
    }
  }

  @media (min-width: ${props => props.theme.breakpoints.lgMin}) {
    display: flex;

    ${ButtonStyle} {
      width: 210px;
    }

    ${ButtonStyle}:first-child {
      margin-right: 20px;
    }
  }
`;

export const ConnectLoggedInStyle = styled.div`
  margin-top: 26px;

  @media (min-width: ${props => props.theme.breakpoints.mdMin}) {
    ${ButtonStyle} {
      width: 228px;
    }
  }

  @media (min-width: ${props => props.theme.breakpoints.lgMin}) {
    ${ButtonStyle} {
      width: 210px;
    }
  }
`;

export const ConnectInputWrapperStyle = styled.div<{ isError: string }>`
  position: relative;
  width: 291px;
  margin: 8px 0 27px;

  @media (min-width: ${props => props.theme.breakpoints.mdMin}) {
    width: 372px;
  }

  &::before {
    content: '\u2013';
    display: block;
    position: absolute;
    top: 0;
    left: 141px;
    line-height: 54px;
    font-size: 20px;
    color: ${Colors.black};

    @media (min-width: ${props => props.theme.breakpoints.mdMin}) {
      left: 181px;
    }
  }

  & .pincode-input-container {
    background-color: ${Colors.darkWhite};
    border: 2px solid !important;
    border-color: ${props => (props.isError ? `${Colors.red} !important` : `${Colors.brownGrey} !important`)};
    border-radius: 6px;
    overflow: hidden;
  }

  & .pincode-input-container:focus-within {
    border-color: ${props => (props.isError ? `${Colors.red} !important` : `${Colors.greenishTeal} !important`)};
  }

  & input {
    box-sizing: content-box;
    width: 31px !important;
    height: 50px !important;
    margin: 0 !important;
    background-color: ${Colors.white} !important;
    border: none !important;
    border-right: 1px solid ${Colors.paleGrey} !important;
    font-size: 20px;
    font-weight: 500;
    color: ${Colors.black};

    @media (min-width: ${props => props.theme.breakpoints.mdMin}) {
      width: 40px !important;
    }
  }
`;

export const ConnectWrongCodeStyle = styled(Heading3)`
  display: block;
  margin-bottom: 6px;
  color: ${Colors.red};
`;
